import React, { useState, useEffect } from 'react';
import { ChevronDown } from 'lucide-react';

const heroImages = [
  'https://res.cloudinary.com/ddclgpokn/image/upload/v1791471743/Tattoo-studio-best-Cornwall-newquay.jpg',
  'https://res.cloudinary.com/ddclgpokn/image/upload/c_crop,g_north,w_1.0,h_0.88/v1776082201/72463AEB-EB81-4384-A602-6C2C857C834A_plrxqc.jpg',
  'https://res.cloudinary.com/ddclgpokn/image/upload/v1776144091/5F0DCE33-C509-4FB9-8DFE-7D29A2E0EC0E_cgyr6j.jpg',
];

const SLIDE_INTERVAL_MS = 6000;

const Hero = () => {
  const [current, setCurrent] = useState(0);
  const [prev, setPrev] = useState(0);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let loaded = 0;
    heroImages.forEach((url) => {
      const img = new Image();
      img.onload = img.onerror = () => { loaded += 1; if (loaded === heroImages.length) setReady(true); };
      img.src = url;
    });
  }, []);

  useEffect(() => {
    if (!ready) return;
    const timer = setInterval(() => {
      setCurrent((i) => {
        setPrev(i);
        return (i + 1) % heroImages.length;
      });
    }, SLIDE_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [ready]);

  const scrollToNext = () => {
    const element = document.getElementById('location');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Slideshow */}
      <div className="absolute inset-0" data-testid="hero-slideshow">
        {heroImages.map((url, i) => (
          <div
            key={url}
            data-testid={`hero-slide-${i}`}
            data-active={i === current}
            className="absolute inset-0 bg-cover bg-center transition-opacity duration-[2000ms] ease-in-out"
            style={{
              backgroundImage: `url('${url}')`,
              opacity: i === current || i === prev ? 1 : 0,
              zIndex: i === current ? 2 : i === prev ? 1 : 0,
            }}
          />
        ))}
        <div className="absolute inset-0 bg-black/70 z-[3]"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4">
        <h1
          data-testid="hero-title"
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white tracking-[0.12em] leading-[1.15] mb-6 animate-fade-in"
          style={{ fontFamily: "'Cinzel Decorative', serif", textShadow: '0 2px 24px rgba(0,0,0,0.6)' }}
        >
          ATLANTIC COAST
          <br />
          TATTOO
        </h1>
        <p
          data-testid="hero-subtitle"
          className="text-sm sm:text-base md:text-lg text-white/80 tracking-[0.3em] animate-fade-in-delay"
        >
          NEWQUAY, 18 CLIFF ROAD, CORNWALL
        </p>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToNext}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white animate-bounce cursor-pointer hover:opacity-70 transition-opacity"
      >
        <div className="flex flex-col items-center">
          <span className="text-xs tracking-widest mb-2">SCROLL DOWN</span>
          <ChevronDown size={32} />
        </div>
      </button>
    </section>
  );
};

export default Hero;
